import React from "react";
import { Skeleton } from "antd";
import ArticleIcon from "@mui/icons-material/Article";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import SchoolIcon from "@mui/icons-material/School";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import styles from "./DashboardContextSection.module.scss";

const formatNumber = (num) => {
  if (num == null || Number.isNaN(num)) return "—";
  return Number(num).toLocaleString();
};

const DashboardContextSection = ({
  data,
  isLoading,
  error,
  selectedKeywords,
}) => {
  const kpiItems = [
    { label: "Publications", key: "publication_count", icon: ArticleIcon },
    { label: "Citations", key: "citation_count", icon: FormatQuoteIcon },
    { label: "Faculty", key: "faculty_count", icon: SchoolIcon },
    { label: "Grants", key: "grants_count", icon: AccountBalanceIcon },
  ];

  const subtitle = selectedKeywords?.length
    ? `Aggregated across ${selectedKeywords.length} research topic${
        selectedKeywords.length > 1 ? "s" : ""
      }.`
    : "Aggregated across the selected research topics.";

  return (
    <section className={styles.section} aria-label="Benchmark context dashboard">
      <div className={styles.head}>
        <span className={styles.eyebrow}>Benchmark Context</span>
        <h2 className={styles.title}>Research landscape overview</h2>
        <p className={styles.subtitle}>{subtitle}</p>
      </div>

      {isLoading ? (
        <div className={styles.skeleton}>
          <Skeleton active paragraph={{ rows: 4 }} />
        </div>
      ) : error ? (
        <div className={styles.error}>
          Unable to load dashboard context. Please try again.
        </div>
      ) : !data ? (
        <div className={styles.empty}>No dashboard data available.</div>
      ) : (
        <div className={styles.kpis}>
          {kpiItems.map((kpi) => (
            <div key={kpi.key} className={styles.kpi}>
              <div className={styles["kpi__head"]}>
                <span className={styles["kpi__icon"]}>
                  <kpi.icon sx={{ fontSize: 16 }} />
                </span>
                <span className={styles["kpi__label"]}>{kpi.label}</span>
              </div>
              <span className={styles["kpi__value"]}>
                {formatNumber(data[kpi.key])}
              </span>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default DashboardContextSection;
